var H = require("hogan.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div id=\"verify-email\" class=\"registration-page bank-common\">");t.b("\n" + i);t.b(t.rp("<rekisteroidy-already-registered-partial0",c,p,"    "));t.b("</div>");return t.fl(); },partials: {"<rekisteroidy-already-registered-partial0":{name:"rekisteroidy-already-registered-partial", partials: {}, subs: {  }}}, subs: {  }}, "<div id=\"verify-email\" class=\"registration-page bank-common\">\n    {{>rekisteroidy-already-registered-partial}}\n</div>", H);return T; }();


//////////////////
// WEBPACK FOOTER
// ./web/views/tunnistaudu-already-identified.mustache
// module id = 871
// module chunks = 2